<template>
    <div class="page-content asset-page">
        <div class="row page-heading mx-0">
			<div class="col-8 input module_heading">
				<span v-if="entity.fileType === 'video'" class="module_icon icon icon-video"></span>
				<span v-if="entity.fileType === 'pdf'" class="module_icon icon icon-file-pdf"></span>
				<span v-if="entity.fileType === 'csv'" class="module_icon icon icon-csvFile"></span>
				<span v-if="entity.fileType === 'txt'" class="module_icon icon icon-file-text"></span>
				<span v-if="entity.fileType === 'mp4' || entity.fileType === 'mp3'" class="module_icon icon icon-video"></span>
				<span v-if="entity.fileType === 'zip'" class="module_icon icon icon-file-zip"></span>
				<span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="module_icon icon icon-file-word"></span>
				<span v-if="entity.fileType === 'xlsx'" class="module_icon icon icon-file-excel"></span>
				<span v-if="entity.fileType === 'html'" class="module_icon icon icon-pageURL"></span>
				<span v-if="entity.fileType === 'other'" class="module_icon icon icon-pageURL"></span>
				<span v-if="entity.fileType === 'externalurl'" class="module_icon icon icon-pageURL"></span>
				<span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="module_icon icon icon-image"></span>
				<b-form-input
					type="text"
					id="title"
					class="module_title-field"
					v-model.trim="entity.title"
					:state="titleState"
					aria-describedby="inputTitleFeedback">
				</b-form-input>
				<b-form-invalid-feedback id="inputTitleFeedback">
					Title must not be empty.
				</b-form-invalid-feedback>
			</div>

			<div class="col-4 float-right px-0">
				<div class="submit btn-container float-right">
					<button
            class="btn-cancel"
            @click="navigateToHome"
            :disabled="submitted"
            :aria-label="$tf('close')"
            :title="$tf('close')"
            v-b-tooltip.hover>
              <span class="icon-cross"></span>
          </button>
					<button
            :class="{disabled: (!entity.title || !model.url)}"
            class="btn btn-primary"
            @click.stop="onSubmit(true)"
            :disabled="submitted"
            :aria-label="$tf('done')">
              {{ $tf('done') }}
          </button>
					<button
            :class="{disabled: (!entity.title || !model.url)}"
            class="btn btn-primary"
            @click.stop="onSubmit(false)"
            :disabled="submitted"
            :aria-label="$tf('save')">
              {{ $tf('save') }}
          </button>
				</div>
			</div>
		</div>
		<div class="row mx-0">
			<div class="asset-left-section">

      <div class="floating_btn_container" tabindex="0">
        <div class="hidden-container mt-3">
          <form method="POST" id="resumeUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
            <input type="file" id="resumeFile" name="file" ref="fileInput" @change="fileToBeUploaded" />
          </form>
        </div>
        <button
          class="btn btn-primary btn_lg_22"
          v-if="isPragyaS3Content()"
          @click.stop="chooseFile"
          aria-label="update file">
            <span class="btn_txt">
              {{ $tf('updateFile') }}
            </span>
          </button>
      </div>


				<div v-if="entity.fileType === 'pdf' || entity.fileType === 'doc' || entity.fileType === 'docx' || entity.fileType === 'pptx' || entity.fileType === 'ppt'|| entity.fileType === 'html' || entity.fileType === 'png' || entity.fileType === 'jpeg' || entity.fileType === 'jpg' || entity.fileType === 'other' || entity.fileType === 'externalurl' || entity.fileType === 'mp3'" class="file_container">
					<p v-if="showLoadingMessage" class="pull-right new_tab_button">
                      <a target="_blank" :href="uri" title="Click here to open this resource in a new tab">
                        <span class="icon-new-tab"></span>
                      </a>
                    </p>
					<iframe id="contentFrame" v-if="showIframe" :src="entity.iframeUrl" frameborder="0"></iframe>
				</div>

				<div v-if="entity.fileType === 'video'" class="file_container">
				    <p v-if="showLoadingMessage" class="pull-right new_tab_button">
                      <a target="_blank" :href="uri" title="Click here to open this resource in a new tab">
                        <span class="icon-new-tab"></span>
                      </a>
                    </p>
					<youtube v-if="!showLoadingMessage" :video-id="entity.yt" ref="youtube" style="width: 100%; height: 86%;"></youtube>
				</div>
			</div>

			<div class="asset-right-section">
				<div class="thumbnail_panel ml-0">
          <div v-if="entity.fileType === 'assessment'">
						<div class="thumbnail_container d-flex icon-assessment" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'video'">
						<div class="thumbnail_container d-flex icon-video" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'pdf'">
						<div class="thumbnail_container d-flex icon-file-pdf" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'csv'">
						<div class="thumbnail_container d-flex icon-csvFile" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'txt'">
						<div class="thumbnail_container d-flex icon-file-text" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'mp4' || entity.fileType === 'mp3'">
						<div class="thumbnail_container d-flex icon-video" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'zip'">
						<div class="thumbnail_container d-flex icon-file-zip" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'doc' || entity.fileType === 'docx'">
						<div class="thumbnail_container d-flex icon-file-word" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'xlsx'">
						<div class="thumbnail_container d-flex icon-file-excel" tabindex="0"></div>
					</div>
          <div v-if="entity.fileType === 'pptx' || entity.fileType === 'ppt'">
						<div class="thumbnail_container d-flex icon-pagePPT" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'html'">
						<div class="thumbnail_container d-flex icon-pageURL" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'externalurl'">
						<div class="thumbnail_container d-flex icon-pageURL" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'">
						<div class="thumbnail_container d-flex icon-image" tabindex="0"></div>
					</div>
					<div v-if="entity.fileType === 'other'">
						<div class="thumbnail_container d-flex icon-asset" tabindex="0"></div>
					</div>

          <div class="row page_section_row">
  					<div class="col-12 heading">
              <label class="ace_sec_txt" tabindex="0">
                {{ $tf('assetDescription') }}
              </label>
            </div>
  					<div class="col-12 value">
  						<textarea rows="4" cols="50"
								id="description"
								placeholder="Type in the asset description..."
								v-model="entity.description" tabindex="0">
							</textarea>
  					</div>
          </div>


          <div class="row page_section_row">
  					<div class="col-12 heading">
              {{ $tf('folder') }}
            </div>
            <div class="col-12 value">
							<template v-if="isShowFolderDropDown">
                <select id="folder" v-model="model.owningLibraryId" @change="changeFolder" aria-labelledby="folderName">
                  <option v-for="folder in folders" :value="folder.uuid">{{ folder.displayName }}</option>
                </select>
              </template>
              <template v-else>
                <div tabindex="0">{{ entity.ancestorName }}</div>
              </template>
						</div>
          </div>


          <template v-if="entity.type === 'REMOTE'">
            <div class="row page_section_row">
    					<div class="col-12 heading" id="assetUrl" tabindex="0">
                URL
              </div>
              <div class="col-12 value">
                <div :class="{invalid: $v.model.url.$error}">
                  <input
                    type="text"
                    id="uri"
                    style="width: 100%;"
                    @blur="$v.model.url.$touch()"
                    aria-labelledby="assetUrl"
                    v-model.trim="model.url">
                  </div>
                </div>
              </div>
            </template>


            <div class="row page_section_row checkbox_container">
    					<div class="col-12 heading" id="assetUrl" tabindex="0">
                <input type="checkbox" class="checkbox_fld" v-model="entity.whiteListed" />
                <label>
                  {{ $tf('displayInline') }}
                </label>
              </div>
            </div>


            <div class="row page_section_row">
              <div class="col-12 heading">
                <span class="ic-tag general"></span>
                <span>
                  {{ $tf('tags') }}
                </span>
                <div class="float-right">
                  <button
                    class="icon-edit ic_btn"
                    type="button"
                    @click="showAddTagPopup($event)"
                    :aria-label="$tf('editTag')"
                    :title="$tf('editTag')"
                    v-b-tooltip.hover>
                  </button>
    						</div>
              </div>
              <div class="col-12 tag-description">
  							<div class="tag-list tags_container" v-if="isTagsAvailable()">
                  <template v-for="(values, key, i) in model.appliedTagMap">
                    <span class="tag ace_sec_txt" v-for="(tag, j) in values">
                      <span class="tag_name" :title="tag.name">{{tag.name}}</span>
                    </span>
                  </template>
  							</div>
  							<div class="tags" v-else style="width: 100%;">
  								<div class="no_tags" style="width: 100%;" tabindex="0"></div>
  							</div>
  						</div>
            </div>
            <template>
              <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
            </template>

				</div>
			</div>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

        <div>
		      <data-loss-prompt ref="dataLossAlert" @okLose="okLose" @saveAndContinue="saveAndContinue"></data-loss-prompt>
		    </div>

    </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import Vuelidate from 'vuelidate'
import AddTagPopup from '../../tagging/components/AddTagPopup'
import {required, url} from 'vuelidate/lib/validators'
// import '../../../assets/module/less/create_entity.less'
import { AwsObject } from '../../learningContent/aws'
import DataLossPrompt from '../../common/components/DataLossPrompt'
  import _ from 'lodash'
Vue.use(Vuelidate)
var FileObject = function (title, file, size, timestamp, type) {
	  this.title = getFileName(title)
	  this.file = file
	  this.fileName = getUpdatedFileName(this.title, title)
	  this.size = size
	  this.contentFileType = type
	  this.timestamp = timestamp
	}
var getFileName = function (fileName) {
	  if (!fileName && fileName !== null) {
	    return null
	  }
	  return fileName.replace(/\.\w+$/g, '')
	}
var getUpdatedFileName = function (title, fileName) {
	  var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
	  if (ext !== '' || ext !== null) {
	    return (title + '.' + ext)
	  } else {
	    return fileName
	  }
	}
var specialDocuments = {
  'csv': 'CSV',
  'dif': 'Data Interchange Format',
  'msword': 'Microsoft Word',
  'doc': 'Microsoft Word',
  'docm': 'Macro Enabled Document',
  'docx': 'Microsoft Word',
  'dot': 'Word 97-2003 Template',
  'dotm': 'Macro Enabled Template',
  'dotx': 'Microsoft Word Template',
  'mht': 'Single Web Page',
  'mhtml': 'Single page html',
  'odt': 'Open Document',
  'pdf': 'PDF',
  'pm': 'Formated Text',
  'ppt': 'Power Point',
  'pptx': 'Power Point',
  'prn': 'PRN',
  'rtf': 'Rich Text Format',
  'slk': 'SYLK',
  'thmx': 'THMX',
  'wps': 'Works 6-9 Document',
  'xls': 'Excel',
  'xlsb': 'Excel Workbook',
  'xlsx': 'Excel',
  'xlsm': 'Excel Macro Enabled Workbook',
  'xlt': 'Excel Template',
  'xps': 'XPS',
  'php': 'PHP',
  'c': 'C'
}

export default {
  name: 'asset-edit',
  props: ['uuid'],
  components: {
    AddTagPopup,
    DataLossPrompt
  },
  data: () => {
    return {
      whiteList: [
        'https://cnx.org/contents/yqV9q0HH@9.765:EjCWRC94@20/Introduction-to-Integers',
        'https://cnx.org/contents/yqV9q0HH@9.765:6XWvp3tz@15/Rational-and-Irrational-Number#fs-id1767079',
        'https://cnx.org/contents/yqV9q0HH@9.765:mPpwTKiz@16/Decimals',
        'https://cnx.org/contents/yqV9q0HH@9.765:eANu7eiL@19/Add-Integers',
        'https://cnx.org/contents/yqV9q0HH@9.765:tl-gRL_E@22/Subtract-Integers',
        'https://cnx.org/contents/yqV9q0HH@9.765:LUUW7a32@17/Multiply-and-Divide-Integers',
        'https://cnx.org/contents/yqV9q0HH@9.765:LUUW7a32@17/Multiply-and-Divide-Integers#fs-id1718637',
        'https://cnx.org/contents/yqV9q0HH@9.765:PMJZgY6F@13/Add-and-Subtract-Fractions-wit',
        'https://cnx.org/contents/yqV9q0HH@9.765:6jhr4kLA@13/Add-and-Subtract-Fractions-wit',
        'https://cnx.org/contents/yqV9q0HH@9.765:PMJZgY6F@13/Add-and-Subtract-Fractions-wit#fs-id1594413',
        'https://cnx.org/contents/yqV9q0HH@9.765:6jhr4kLA@13/Add-and-Subtract-Fractions-wit#fs-id1276143',
        'https://cnx.org/contents/yqV9q0HH@9.765:s7ku6WX5@18/Multiply-and-Divide-Fractions',
        'https://cnx.org/contents/yqV9q0HH@9.765:0L7hpyVK@15/Decimal-Operations#fs-id1358621',
        'https://cnx.org/contents/yqV9q0HH@9.765:s7ku6WX5@18/Multiply-and-Divide-Fractions#fs-id2700526',
        'https://cnx.org/contents/yqV9q0HH@9.765:0L7hpyVK@15/Decimal-Operations#fs-id2471378',
        'https://cnx.org/contents/yqV9q0HH@9.765:iIOMae_5@20/Understand-Percent',
        'https://cnx.org/contents/yqV9q0HH@9.765:534pfj8-@15/Use-the-Language-of-Algebra#fs-id1395398',
        'https://cnx.org/contents/yqV9q0HH@9.765:534pfj8-@15/Use-the-Language-of-Algebra#fs-id2661619',
        'https://cnx.org/contents/yqV9q0HH@9.765:534pfj8-@15/Use-the-Language-of-Algebra#fs-id2139130',
        'https://cnx.org/contents/yqV9q0HH@9.765:LUUW7a32@17/Multiply-and-Divide-Integers#fs-id1714226',
        'https://cnx.org/contents/yqV9q0HH@9.765:LUUW7a32@17/Multiply-and-Divide-Integers#fs-id1919519',
        'https://cnx.org/contents/yqV9q0HH@9.765:534pfj8-@15/Use-the-Language-of-Algebra#fs-id1193286',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/Evaluate-Simplify-and-Translat#fs-id1733229',
        'https://cnx.org/contents/yqV9q0HH@9.765:nmU2s-CD@13/Commutative-and-Associative-Pr',
        'https://cnx.org/contents/yqV9q0HH@9.765:6kJ5Z57B@13/Distributive-Property',
        'https://cnx.org/contents/yqV9q0HH@9.765:IOqEQ0kt@12/Properties-of-Identity-Inverse',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/  Evaluate-Simplify-and-Translat#fs-id1232396',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/Evaluate-Simplify-and-Translat#fs-id2241263',
        'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/Evaluate-Simplify-and-Translat#fs-id2707610',
        'https://cnx.org/contents/yqV9q0HH@9.765:6XWvp3tz@15/Rational-and-Irrational-Number#fs-id1535083',
        'https://cnx.org/contents/yqV9q0HH@9.765:nmU2s-CD@13/Commutative-and-Associative-Pr#fs-id1166478989599',
        'https://cnx.org/contents/yqV9q0HH@9.765:IOqEQ0kt@12/Properties-of-Identity-Inverse#fs-id1166497460665',
        'https://cnx.org/contents/yqV9q0HH@9.765:IOqEQ0kt@12/Properties-of-Identity-Inverse#fs-id1166497481181',
        'https://cnx.org/contents/yqV9q0HH@9.765:IOqEQ0kt@12/Properties-of-Identity-Inverse#fs-id1166497459880',
        'https://cnx.org/contents/yqV9q0HH@9.765:cY13ivLF@13/Solve-Equations-with-Variables',
        'https://cnx.org/contents/yqV9q0HH@9.765:9eEtMKQa@19/Solving-Equations-Using-the-Su#fs-id2318611',
        'https://cnx.org/contents/yqV9q0HH@9.765:6e_1mRFC@14/Solve-Equations-Using-the-Subt',
        'https://cnx.org/contents/yqV9q0HH@9.765:nzp1RlZu@13/Solve-Equations-Using-the-Divi',
        'https://cnx.org/contents/yqV9q0HH@9.765:534pfj8-@15/Use-the-Language-of-Algebra#fs-id2139102',
        'https://cnx.org/contents/yqV9q0HH@9.765:9eEtMKQa@19/Solving-Equations-Using-the-Su#fs-id1549757',
        'https://cnx.org/contents/yqV9q0HH@9.765:UGK4inAC@17/Use-a-Problem-Solving-Strategy#fs-id1533728',
        'https://cnx.org/contents/yqV9q0HH@9.765:FRtcjj64@21/Solve-Sales-Tax-Commission-and#fs-id1499142',
        'https://cnx.org/contents/yqV9q0HH@9.765:plAnVHMc@20/Solve-Simple-Interest-Applicat',
        'https://cnx.org/contents/yqV9q0HH@9.765:IwAsSXsh@19/Solve-a-Formula-for-a-Specific',
        'https://cnx.org/contents/yqV9q0HH@9.765:jq9gwbWo@12/Add-Whole-Numbers#fs-id2594070',
        'https://cnx.org/contents/yqV9q0HH@9.765:HpMawx93@20/Use-Properties-of-Rectangles-T#fs-id1171505778736',
        'https://cnx.org/contents/yqV9q0HH@9.765:4A4IPh7R@20/Use-Properties-of-Angles-Trian',
        'https://cnx.org/contents/yqV9q0HH@9.765:HpMawx93@20/Use-Properties-of-Rectangles-T#fs-id1797142',
        'https://cnx.org/contents/yqV9q0HH@9.765:Lvahg2k3@20/Use-the-Rectangular-Coordinate',
        'https://cnx.org/contents/yqV9q0HH@9.765:zf9Dhl3V@19/Understand-Slope-of-a-Line',
        'https://cnx.org/contents/yqV9q0HH@9.765:j1MbsS9b@19/Graphing-Linear-Equations#fs-id1515845',
        'https://cnx.org/contents/yqV9q0HH@9.765:j1MbsS9b@19/Graphing-Linear-Equations',
        'https://cnx.org/contents/CImQfPDv@2.44:lBmVYBst@3/Add-and-Subtract-Integers#fs-id1170655124054',
        'https://cnx.org/contents/CImQfPDv@2.44:HRhzJGFq@3/Visualize-Fractions',
        'https://cnx.org/contents/CImQfPDv@2.44:lBmVYBst@3/Add-and-Subtract-Integers#fs-id1170654942142',
        'https://cnx.org/contents/CImQfPDv@2.44:lBmVYBst@3/Add-and-Subtract-Integers#fs-id1170654942216',
        'https://cnx.org/contents/CImQfPDv@2.44:DgkT5Ky_@2/Multiply-and-Divide-Integers#fs-id1170652620585',
        'https://cnx.org/contents/CImQfPDv@2.44:DgkT5Ky_@2/Multiply-and-Divide-Integers#fs-id1170653874776',
        'https://cnx.org/contents/CImQfPDv@2.44:s3Hqb5IM@2/Add-and-Subtract-Fractions',
        'https://cnx.org/contents/CImQfPDv@2.44:HRhzJGFq@3/Visualize-Fractions#fs-id1170653910468',
        'https://cnx.org/contents/CImQfPDv@2.44:HRhzJGFq@3/Visualize-Fractions#fs-id1170654110168',
        'https://cnx.org/contents/CImQfPDv@2.44:NciJ1qa0@3/Decimals#fs-id1170655102379',
        'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654982105',
        'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654942632',
        'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654928809',
        'https://cnx.org/contents/CImQfPDv@2.44:DgkT5Ky_@2/Multiply-and-Divide-Integers#fs-id1170653761875',
        'https://cnx.org/contents/CImQfPDv@2.44:DgkT5Ky_@2/Multiply-and-Divide-Integers#fs-id1170652624016',
        'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654953465',
        'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170655163482',
        'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers',
        'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654889475',
        'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654942537',
        'https://cnx.org/contents/CImQfPDv@2.44:dgB2SHi0@3/The-Real-Numbers#fs-id1170655121069',
        'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers#fs-id1170653871089',
        'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers#fs-id1170653774811',
        'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers#fs-id1170654074010',
        'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers#fs-id1170653800718',
        'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers#fs-id1170654077757',
        'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654957085',
        'https://cnx.org/contents/CImQfPDv@2.44:OWpkn8_G@2/Solve-Equations-Using-the-Subt#fs-id1168345560615',
        'https://cnx.org/contents/CImQfPDv@2.44:OWpkn8_G@2/Solve-Equations-Using-the-Subt',
        'https://cnx.org/contents/CImQfPDv@2.44:9ujtiwpG@2/Solve-Equations-using-the-Divi',
        'https://cnx.org/contents/CImQfPDv@2.44:4GK6JSQo@2/Solve-Linear-Inequalities',
        'https://cnx.org/contents/CImQfPDv@2.44:4GK6JSQo@2/Solve-Linear-Inequalities#fs-id1168341960485',
        'https://cnx.org/contents/CImQfPDv@2.44:4GK6JSQo@2/Solve-Linear-Inequalities#fs-id1168345517735',
        'https://cnx.org/contents/CImQfPDv@2.44:4GK6JSQo@2/Solve-Linear-Inequalities#fs-id1168345667361',
        'https://cnx.org/contents/CImQfPDv@2.44:4GK6JSQo@2/Solve-Linear-Inequalities#fs-id1168345500407',
        'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654938230',
        'https://cnx.org/contents/CImQfPDv@2.44:Tj87ETCR@3/Use-a-Problem-Solving-Strategy',
        'https://cnx.org/contents/CImQfPDv@2.44:Tj87ETCR@3/Use-a-Problem-Solving-Strategy#fs-id1168344319176',
        'https://cnx.org/contents/CImQfPDv@2.44:RMC_iBKa@2/Solve-Percent-Applications#fs-id1168345389218',
        'https://cnx.org/contents/CImQfPDv@2.44:Z8sTwcjE@3/Solve-Mixture-Applications#fs-id1168345458172',
        'https://cnx.org/contents/CImQfPDv@2.44:Z8sTwcjE@3/Solve-Mixture-Applications#fs-id1168345415718',
        'https://cnx.org/contents/CImQfPDv@2.44:Dt6yb2pr@3/Solve-Uniform-Motion-Applicati',
        'https://cnx.org/contents/CImQfPDv@2.44:BW6bMUQm@2/Solve-Geometry-Applications-Tr#fs-id1168345561789',
        'https://cnx.org/contents/CImQfPDv@2.44:BW6bMUQm@2/Solve-Geometry-Applications-Tr#fs-id1168345363664',
        'https://cnx.org/contents/CImQfPDv@2.44:THpXLlSz@2/Solve-Applications-with-Linear',
        'https://cnx.org/contents/CImQfPDv@2.44:S6EErGb5@3/Use-the-Rectangular-Coordinate',
        'https://cnx.org/contents/CImQfPDv@2.44:ukK0bN45@2/Understand-Slope-of-a-Line',
        'https://cnx.org/contents/CImQfPDv@2.44:tegV4wXG@4/Use-the-SlopeIntercept-Form-of',
        'https://cnx.org/contents/CImQfPDv@2.44:_LEEVWcM@2/Find-the-Equation-of-a-Line#fs-id1169596704299',
        'https://cnx.org/contents/CImQfPDv@2.44:_LEEVWcM@2/Find-the-Equation-of-a-Line#fs-id1169596497114',
        'https://cnx.org/contents/CImQfPDv@2.44:_LEEVWcM@2/Find-the-Equation-of-a-Line#fs-id1169596441994',
        'https://cnx.org/contents/CImQfPDv@2.44:uoU4SZ4O@2/Graph-Linear-Equations-in-Two-#fs-id1169596298887',
        'https://cnx.org/contents/CImQfPDv@2.44:uoU4SZ4O@2/Graph-Linear-Equations-in-Two-#fs-id1169596497621',
        'https://cnx.org/contents/CImQfPDv@2.44:1fOoAbOR@3/Graphs-of-Linear-Inequalities#fs-id1169596219884',
        'https://cnx.org/contents/CImQfPDv@2.44:1fOoAbOR@3/Graphs-of-Linear-Inequalities#fs-id1169596441313',
        'http://cdn.kutasoftware.com/Worksheets/Alg1/Graphing%20Linear%20Inequalities.pdf',
        'http://www.wallace.ccfaculty.org/book/0.1%20Integers.pdf',
        'http://www.wallace.ccfaculty.org/book/0.2%20Fractions.pdf',
        'http://www.wallace.ccfaculty.org/book/0.4%20Properties%20of%20Algebra.pdf',
        'http://www.wallace.ccfaculty.org/book/0.4%20Properties%20of%20Algebra%20Practice.pdf',
        'http://www.wallace.ccfaculty.org/book/1.1%20One-Step%20Equations.pdf',
        'http://www.wallace.ccfaculty.org/book/2.2%20Slope.pdf',
        'http://www.wallace.ccfaculty.org/book/2.2%20Slope%20Practice.pdf',
        'http://www.wallace.ccfaculty.org/book/2.3%20Slope%20Intercept%20Practice.pdf',
        'http://www.wallace.ccfaculty.org/book/2.4%20Point-Slope%20Practice.pdf',
        'http://www.wallace.ccfaculty.org/book/3.1%20Simple%20Inequalities%20Practice.pdf',
        'http://www.wallace.ccfaculty.org/book/Beginning_and_Intermediate_Algebra.pdf',
        'https://courses.lumenlearning.com/beginalgebra/chapter/rules-for-adding-real-numbers/',
        'https://courses.lumenlearning.com/boundless-algebra/chapter/variables-and-expressions/',
        'https://courses.lumenlearning.com/boundless-algebra/chapter/further-exponents/',
        'https://courses.lumenlearning.com/boundless-algebra/chapter/introduction-to-arithmetic-operations/',
        'https://www.boundless.com/algebra/textbooks/boundless-algebra-textbook/introduction-to-equations-inequalities-and-graphing-2/variables-and-expressions-16/introduction-to-variables-368-17412/',
        'https://www.cliffsnotes.com/study-guides/algebra/algebra-i/preliminaries-and-basic-operations/properties-of-basic-mathematical-operations',
        'https://www.cliffsnotes.com/study-guides/algebra/algebra-i/terminology-sets-and-expressions/variables-and-algebraic-expressions',
        'https://www.cliffsnotes.com/study-guides/basic-math/basic-math-and-pre-algebra/variables-algebraic-expressions-and-simple-equations/variables-and-algebraic-expressions',
        'https://cnx.org/contents/CImQfPDv@2.44:D5n2sgz3@3/Solve-Systems-of-Equations-by-#fs-id1168341923821',
        'https://cnx.org/contents/CImQfPDv@2.44:D5n2sgz3@3/Solve-Systems-of-Equations-by-#fs-id1168345440846',
        'https://cnx.org/contents/CImQfPDv@2.44:D5n2sgz3@3/Solve-Systems-of-Equations-by-#CNX_ElemAlg_Figure_05_01_015',
        'https://cnx.org/contents/CImQfPDv@2.44:jLGlZ6m5@3/Solve-Systems-of-Equations-by-#fs-id1168345216137',
        'https://cnx.org/contents/CImQfPDv@2.44:jLGlZ6m5@3/Solve-Systems-of-Equations-by-#fs-id1168345695456',
        'https://cnx.org/contents/CImQfPDv@2.44:jLGlZ6m5@3/Solve-Systems-of-Equations-by-#fs-id1168345285072',
        'https://cnx.org/contents/CImQfPDv@2.44:V1Ef26Jq@2/Solve-Systems-of-Equations-by-#fs-id1168345742458',
        'https://cnx.org/contents/CImQfPDv@2.44:V1Ef26Jq@2/Solve-Systems-of-Equations-by-#fs-id1168345511491',
        'https://cnx.org/contents/CImQfPDv@2.44:V1Ef26Jq@2/Solve-Systems-of-Equations-by-#fs-id1168345357619',
        'https://cnx.org/contents/CImQfPDv@2.44:ZArS1Z0P@5/Solve-Applications-with-System#fs-id1168344525268',
        'https://cnx.org/contents/CImQfPDv@2.44:ZArS1Z0P@5/Solve-Applications-with-System#fs-id1168343064826',
        'https://cnx.org/contents/CImQfPDv@2.44:SadrhUaw@2/Add-and-Subtract-Polynomials#fs-id1169596392601',
        'https://cnx.org/contents/CImQfPDv@2.44:SadrhUaw@2/Add-and-Subtract-Polynomials#fs-id1169596396806',
        'https://cnx.org/contents/CImQfPDv@2.44:SadrhUaw@2/Add-and-Subtract-Polynomials#fs-id1169596453928',
        'https://cnx.org/contents/CImQfPDv@2.44:SadrhUaw@2/Add-and-Subtract-Polynomials#fs-id1169596365153',
        'https://cnx.org/contents/CImQfPDv@2.44:UeFfacK9@2/Multiply-Polynomials#fs-id1169596397302',
        'https://cnx.org/contents/CImQfPDv@2.44:UeFfacK9@2/Multiply-Polynomials#fs-id1169596410084',
        'https://cnx.org/contents/CImQfPDv@2.44:UeFfacK9@2/Multiply-Polynomials#fs-id1169596303926',
        'https://cnx.org/contents/CImQfPDv@2.44:R3vcJIkA@4/Special-Products',
        'https://cnx.org/contents/CImQfPDv@2.44:i_n2_vn1@2/Integer-Exponents-and-Scientif#fs-id1169597494141',
        'https://cnx.org/contents/CImQfPDv@2.44:i_n2_vn1@2/Integer-Exponents-and-Scientif#fs-id1169597539588',
        'https://cnx.org/contents/CImQfPDv@2.44:i_n2_vn1@2/Integer-Exponents-and-Scientif#fs-id1169597689465',
        'https://cnx.org/contents/CImQfPDv@2.44:SSXOP9oB@4/Divide-Polynomials#fs-id1169597410581',
        'https://cnx.org/contents/CImQfPDv@2.44:SSXOP9oB@4/Divide-Polynomials#fs-id1169597481790',
        'https://cnx.org/contents/CImQfPDv@2.44:Dgyhg24R@3/Greatest-Common-Factor-and-Fac#fs-id1168341853057',
        'https://cnx.org/contents/CImQfPDv@2.44:Dgyhg24R@3/Greatest-Common-Factor-and-Fac#fs-id1168345277984',
        'https://cnx.org/contents/CImQfPDv@2.44:Dgyhg24R@3/Greatest-Common-Factor-and-Fac#fs-id1168345406018',
        'https://cnx.org/contents/CImQfPDv@2.44:KekUrtBj@5/Factor-Quadratic-Trinomials-wi',
        'https://cnx.org/contents/CImQfPDv@2.44:ntLHiuvZ@3/Factor-Quadratic-Trinomials-wi',
        'https://cnx.org/contents/CImQfPDv@2.44:p-75hORO/Factor-Special-Products',
        'https://cnx.org/contents/CImQfPDv@2.44:WId3lCUh@2/Simplify-Rational-Expressions#fs-id1169596555147',
        'https://cnx.org/contents/CImQfPDv@2.44:WId3lCUh@2/Simplify-Rational-Expressions#fs-id1169596765280',
        'https://cnx.org/contents/CImQfPDv@2.44:WId3lCUh@2/Simplify-Rational-Expressions#fs-id1169596234350',
        'https://cnx.org/contents/CImQfPDv@2.44:H1BI5dWO@2/Multiply-and-Divide-Rational-E#fs-id1169597485048',
        'https://cnx.org/contents/CImQfPDv@2.44:H1BI5dWO@2/Multiply-and-Divide-Rational-E#fs-id1169595235043',
        'https://cnx.org/contents/CImQfPDv@2.44:Q1yBn-wZ@2/Add-and-Subtract-Rational-Expr',
        'https://cnx.org/contents/CImQfPDv@2.44:9_tGuTDU@2/Add-and-Subtract-Rational-Expr#fs-id1169597479058',
        'https://cnx.org/contents/CImQfPDv@2.44:9_tGuTDU@2/Add-and-Subtract-Rational-Expr',
        'https://cnx.org/contents/CImQfPDv@2.44:QiOXd9L3@2/Simplify-Complex-Rational-Expr',
        'https://cnx.org/contents/CImQfPDv@2.44:lD27fVyp@2/Solve-Rational-Equations',
        'https://cnx.org/contents/CImQfPDv@2.44:lD27fVyp@2/Solve-Rational-Equations#fs-id1169597705349',
        'https://cnx.org/contents/CImQfPDv@2.44:s2Pana65@2/Solve-Proportion-and-Similar-F',
        'https://cnx.org/contents/CImQfPDv@2.44:DyIv0UeH@2/Simplify-and-Use-Square-Roots',
        'https://cnx.org/contents/CImQfPDv@2.44:wDB3sj46@2/Simplify-Square-Roots',
        'https://cnx.org/contents/CImQfPDv@2.44:DyIv0UeH@2/Simplify-and-Use-Square-Roots#fs-id1169596704683',
        'https://cnx.org/contents/CImQfPDv@2.44:wDB3sj46@2/Simplify-Square-Roots#fs-id1169596453704',
        'https://cnx.org/contents/CImQfPDv@2.44:vfPRgYoW@2/Add-and-Subtract-Square-Roots',
        'https://cnx.org/contents/CImQfPDv@2.44:K59eZ3ai/Multiply-Square-Roots',
        'https://cnx.org/contents/CImQfPDv@2.44:20M2B5Ot@2/Divide-Square-Roots',
        'https://cnx.org/contents/CImQfPDv@2.44:vfPRgYoW@2/Add-and-Subtract-Square-Roots#fs-id1169596685926',
        'https://cnx.org/contents/CImQfPDv@2.44:K59eZ3ai@2/Multiply-Square-Roots#fs-id1169595122726',
        'https://cnx.org/contents/CImQfPDv@2.44:20M2B5Ot@2/Divide-Square-Roots#fs-id1169596348306',
        'https://cnx.org/contents/CImQfPDv@2.44:DHh18HNo@2/Quadratic-Equations#fs-id1168345500421',
        'https://cnx.org/contents/CImQfPDv@2.44:Xk8nuhrb@2/Solve-Quadratic-Equations-Usin',
        'https://cnx.org/contents/CImQfPDv@2.44:bs9oZaKb@2/Solve-Quadratic-Equations-by-C',
        'https://cnx.org/contents/CImQfPDv@2.44:mwyQCpKo@2/Solve-Quadratic-Equations-Usin',
        'https://s3.amazonaws.com/nile-nu-dev-content/024fb4b1-ca40-4e08-8450-44a4a7829566.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/0403becb-788d-409b-b93e-c6807c6411a9.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/0e3e5f54-5364-432e-8549-bb516fd702b2.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/268f27b8-595e-4a06-8530-2291f9418e38.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/29a1850f-cee9-4b62-bf57-d8e2bbb04f0f.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/37392129-5771-4144-a6ce-02983392c2c9.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/3fe33b41-eea9-49c1-9004-214621f16cfb.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/4f89ba44-3802-431e-8062-40487000d30f.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/6986e8c4-3743-4292-b04e-a6725cbdc9f7.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/6ce067ec-dfc2-4bd4-8cb4-645419209054.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/813305c5-0a83-4699-9ab7-3aeb2e7133f9.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/915cccc3-ce32-43cf-9548-a5402a005806.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/9f045751-c0d5-4698-adb9-a7cc79893ef9.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/a730b171-1d6a-44c3-b4a0-a3acd3824306.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/aba61895-519b-4f4d-9caf-ca6cd18e6124.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/bfcf596a-77a3-4405-ab55-67f175424ab3.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/c2193755-bd34-47cd-a209-e823d037267c.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/caedbed3-f4b5-4475-8b2e-9bc7d3b05ce9.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/e767dfc6-c3d2-4a25-ac92-682739901473.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/e7d5f2de-e83d-4db0-b6c3-1cfdf8e9650c.pdf',
        'https://s3.amazonaws.com/nile-nu-dev-content/fdca1243-355d-4059-95fe-b31d31f4f17c.pdf',
        'http://www.wallace.ccfaculty.org/book/4.1%20Graphing%20Systems%20Practice.pdf',
        'http://www.wallace.ccfaculty.org/book/4.2%20Substitution%20Practice.pdf',
        'https://www.algebra.com/algebra/homework/coordinate/Types-of-systems-inconsistent-dependent-independent.lesson',
        'https://www.wyzant.com/resources/lessons/math/algebra/simplifying-negative-exponents',
        'https://www.mathportal.org/algebra/solving-system-of-linear-equations/substitution-method.php',
        'https://www.mathportal.org/algebra/roots-and-radicals/adding-and-subtracting-radicals.php',
        'https://www.mathplanet.com/education/algebra-1/rational-expressions/multiply-rational-expressions',
        'https://www.ck12.org/book/CK-12-Algebra-II-with-Trigonometry-Concepts/section/3.5/',
        'https://themathlab.com/Algebra/polynomials/divpoly.htm',
        'https://www.basic-mathematics.com/elimination-method.html'
      ],
      showLoadingMessage: true,
      submitted: false,
      uri: '',
      folders: [],
      ancestor: '',
      isShowFolderDropDown: false,
      model: {
      	url: '',
	      owningLibraryId: '',
	      appliedTagMap: {}
      },
      taggingEntityData: {},
      isShowTagPopup: false,
      blackList: [
        'https://ca.pbslearningmedia.org/resource/lsps07.sci.phys.matter.covalentbond/covalent-bonding/#.WO64mNLytPY',
        'https://ca.pbslearningmedia.org/resource/7eb9615f-f534-4772-b65d-6c5117768a66/chemistry-501-introduction-to-bonding/#.WO62-9LytPY',
        'https://ca.pbslearningmedia.org/resource/75151b40-5d55-42d3-9975-a150cfd72c41/chemistry-701-introduction-to-the-mole-and-molar-mass/#.WzLKo9VKiUk',
        'https://www.tiki-toki.com/timeline/entry/64373/History-of-Educational-Technology/#vars!date=0321-02-05_10:36:14!',
        'https://writingcommons.org/chapters/the-writing-process/staying-focused/146-the-common-topoi-and-tagmemic-questions',
        'http://web.mnstate.edu/',
        'https://www.purplemath.com/',
        'https://www.toppr.com/',
        'https://www.khanacademy.org/',
        'http://www.montereyinstitute.org/',
        'https://study.com/',
        'http://www.mathplanet.com/',
        'http://jwilson.coe.uga.edu/'
      ],
      showIframe: true,
      nextPage: undefined,
      dirty: false,
      oldModel: {},
      oldEntity: {}
    }
  },

  validations: {
  	model: {
	    url: {
	      required,
	      url
	    }
    }
  },

  beforeRouteLeave (to, from, next) {
    if (this.dirty) {
      this.nextPage = next
      this.$refs.dataLossAlert.showPrompt()
      next(false)
    } else {
      next()
    }
  },

  mounted () {
    this.loadAsset()
    this.loadCurrentEnvironment().then(res => {
        AwsObject(res)
      })
  },

  methods: {
    ...mapActions([
      'loadLibrariesForUser',
      'loadEntityDetail',
      'updateAssetMetaData',
      'loadCurrentEnvironment'
    ]),

    loadAsset () {
      var entityDetailInfo = {
        'entityUuid': this.uuid,
        'entityType': 'LearningContent'
      }
      const userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(userId).then(learningSpaces => {
        this.folders = []
        for (var i = 0; i < learningSpaces.length; i++) {
          const learningSpace = learningSpaces[i]
          const permission = learningSpace.acelist[0].permission
          if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
            this.folders.push(learningSpace)
          }
        }
        var userObject = JSON.parse(localStorage.getItem('userobj'))
        var libraries = userObject.userPreferences.learningSpaces
        if (this.folders.length > 0) {
          this.loadEntityDetail(entityDetailInfo).then(res => {
            this.model.url = res.uri
            this.ancestor = res.ancestor
            this.model.owningLibraryId = res.owningLibraryId
            this.isShowFolderDropDown = ($.inArray(this.ancestor, libraries) !== -1)
            this.uri = this.handleSpecialDocuments(res)
            if (res.appliedTagMap) {
              // this.tags = res.appliedTagMap.general
              this.model.appliedTagMap = res.appliedTagMap
            }
            if (res.whiteListed) {
              this.showLoadingMessage = !((res.fileType === 'video') || ((res.fileType === 'other') && (res.contentFileType.indexOf('video') !== -1)))
            } else {
              if (res.blackListed) {
                this.showIframe = false
              } else {
                this.entity.whiteListed = true
              }
            }
            if (!res.whiteListed && !res.blackListed) {
              if (this.showLoadingMessage) {
                for (var i = 0; i < this.whiteList.length; i++) {
                  if (res.uri === this.whiteList[i]) {
                    this.showLoadingMessage = false
                    break
                  }
                }
              }
              if (this.showIframe) {
                for (var j = 0; j < this.blackList.length; j++) {
                  let resourceUrl = this.blackList[j]
                  if ((this.entity.uri === resourceUrl) || (this.entity.uri.indexOf(resourceUrl) !== -1)) {
                    this.showIframe = false
                    break
                  }
                }
              }
            }
            this.$data.oldEntity = _.cloneDeep(this.entity)
            this.$data.oldModel = _.cloneDeep(this.$data.model)
          })
        }
      })
    },

    changeFolder () {
      this.ancestor = this.model.owningLibraryId
    },

    isTagsAvailable () {
      let values = Object.values(this.model.appliedTagMap)
      return values.find((value) => {
        return value.length > 0
      })
    },

    showAddTagPopup (event) {
      this.isShowTagPopup = true
      this.taggingEntityData = {title: this.entity.title, type: 'assets', appliedTagMap: this.model.appliedTagMap}
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
      }, 500)
    },

    handleSpecialDocuments (content) {
      if (specialDocuments[content.fileType]) {
        var uri = content.uri
        var versionIdWithValue = ''
        if (uri.indexOf('?versionId=') !== -1) {
          versionIdWithValue = uri.substring(uri.indexOf('?versionId='), uri.length)
          uri = uri.substring(0, uri.indexOf('?versionId='))
        }
        if (this.isUriContainsSpecialCharacter(uri)) {
          var modifiedUri = uri.substring(0, uri.lastIndexOf('/'))
          modifiedUri = modifiedUri.concat('/').concat(encodeURIComponent(uri.substring(uri.lastIndexOf('/') + 1, uri.length)))
          let encodedUri = encodeURIComponent(modifiedUri)
          encodedUri += versionIdWithValue
          return (content.fileType === 'pdf' && encodedUri.indexOf('s3-us-west-2.amazonaws.com') !== -1) ? decodeURIComponent(encodedUri) : ('https://drive.google.com/viewerng/viewer?url=' + encodedUri + '&embedded=true')
        }
        let encodedUri = encodeURIComponent(uri)
        encodedUri += versionIdWithValue
        return (content.fileType === 'pdf' && encodedUri.indexOf('s3-us-west-2.amazonaws.com') !== -1) ? decodeURIComponent(encodedUri) : ('https://drive.google.com/viewerng/viewer?url=' + encodedUri + '&embedded=true')
      }
      return content.uri
    },

    isUriContainsSpecialCharacter (uri) {
      return uri.indexOf('+') !== -1 || uri.indexOf('#') !== -1 || uri.indexOf('%') !== -1 || uri.indexOf('&') !== -1 || uri.indexOf('') !== -1
    },

    navigateToHome () {
      return this.$router.push({ name: 'assetPreview', params: { uuid: this.uuid } })
    },
    isPragyaS3Content () {
    	if(this.model.url.indexOf("pragya2.s3-us-west-2.amazonaws.com") !=-1){
    		return true
    	}
    	if(this.model.url.indexOf("d8u9i8cr919vu.cloudfront.net") !=-1){
    		return true
    	}
    	if(this.model.url.indexOf("pragya2-staging.s3-us-west-2.amazonaws.com") !=-1){
    		return true
    	}
    	if(this.model.url.indexOf("dchdmyf3sk7bh.cloudfront.net") !=-1){
    		return true
    	}
    	if(this.model.url.indexOf("pragya2-local.s3-us-west-2.amazonaws.com") !=-1){
    		return true
    	}
    	if(this.model.url.indexOf("d1kecady0erq42.cloudfront.net") !=-1){
    		return true
    	}
    	return false
    },
    chooseFile () {
		let sel = 'id=resumeFile'
        $('input[type=file][' + sel + ']').click()
	},
	fileToBeUploaded (ev) {
        let files = ev.target.files || ev.dataTransfer.files
        if (!files.length) {
          return
        }
        this.file = files[0]
    	let size = this.file.size
    	if (Math.abs(size/20971520) <= 1) {
//    		this.showLoader()
        	let timestamp = new Date().getTime()
          	let fileData = new FileObject(this.file.name, this.file, size, timestamp, this.file.type)
          	let id = this.uuid
//          	let key = this.getKeyFromOldURI(this.model.url)
			let key = id + '-' + fileData.fileName
	      	this.storeFilesToS3({id: id, key: key, fileData: fileData})
    	} else {
//    		this.hideLoader()
//    		this.clearFilePath()
    		this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'File size should be less than 20 MB.'
          })
    	}
      },
      getKeyFromOldURI(oldOul){
      	let oldKey =  oldOul.substring(oldOul.lastIndexOf('/') + 1);
      	oldKey = oldKey.substring(0, oldKey.indexOf('?'))
      	return oldKey
      },
      storeFilesToS3 (item) {
      	let s3AwsRef = new AWS.S3()
        let s3Bucket = this.currentEnvironment.s3Bucket
        let fileName = item.fileData.fileName
        var params = {
          Key: item.key,
          Bucket: s3Bucket,
          ContentType: item.fileData.contentFileType,
          ACL: 'public-read',
          Body: item.fileData.file
        }
        s3AwsRef.putObject(params, (err, data) => {
          if (err) {
           alert(err)
//          	this.clearFilePath()
//            this.hideLoader()
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: '<strong>"' + fileName + '" failed To upload.</strong>'
            })
          } else {
          	let uploadedVersions = []
	          let fileUrl = 'https://'.concat(s3Bucket).concat('.s3-us-west-2.amazonaws.com/').concat(item.key).concat('?versionId=' + data.VersionId)
	          document.getElementById('contentFrame').src = 'https://drive.google.com/viewerng/viewer?url=' + fileUrl + '&embedded=true'
	          this.showIframe = true
	          this.model.url = fileUrl
	          	this.$notify({
		            group: 'notify',
		            type: 'success',
		            title: '',
		            text: '<strong>uploaded successfully.</strong>'
		          })
          }
        })
      },
    onSubmit (isDone) {
      if (this.$v.model.url.$error) {
        return
      }
      this.dirty = false
      this.$refs.loadingModal.show()
      this.submitted = true
      // const appliedTagMap = {general: this.tags}
      this.entity.appliedTagMap = this.model.appliedTagMap
      this.entity.uri = this.model.url
      this.entity.ancestor = this.ancestor
      this.entity.owningLibraryId = this.model.owningLibraryId
      this.entity.isWhiteListed = this.entity.whiteListed
      this.entity.isBlackListed = this.entity.blackListed
      this.$data.oldModel = _.cloneDeep(this.$data.model)
      this.$data.oldEntity = _.cloneDeep(this.entity)
      this.updateAssetMetaData(this.entity).then(res => {
        this.$refs.loadingModal.hide()
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Asset "' + this.entity.title + '" updated successfully.'
        })
        if (isDone) {
        	if (this.nextPage) {
            this.$emit('resolveNext', this.nextPage)
          } else {
          	return this.$router.push({ name: 'assetPreview', params: { uuid: this.uuid } })
          }
        } else {
          this.submitted = false
        }
      })
    },

    okLose () {
      this.$emit('resolveNext', this.nextPage)
    },

    saveAndContinue () {
      this.onSubmit(true)
    }
  },

  watch: {
    model: {
      handler () {
        this.dirty = !_.isEqual(this.$data.model, this.$data.oldModel)
      },
      deep: true
    },
    entity: {
      handler () {
        this.dirty = !_.isEqual(this.entity, this.$data.oldEntity)
      },
      deep: true
    }
  },

  computed: {
    ...mapState({
      'entity': state => state.course.entity,
      'currentEnvironment': state => state.learningContent.currentEnvironment

    }),

    titleState () {
      return this.entity.title.length > 0
    }
  }
}
</script>

<style scoped>
.hidden-container {
  visibility: hidden;
  height: 1px;
}
.header {
    background: #f7e5a8;
    margin-bottom: 30px;
    float: left;
    width: 100%;
    padding-left: 20px;
    height:62px;
}
.icon {
    color: #b8652a;
    font-size: 40px;
    margin: 12px 10px 0 0px;
    float: left;
}

.icon-file-pdf, .icon-file-word, .icon-file-excel, .icon-pageURL, .icon-image {
    font-size: 26px;
    margin-top: 18px;
}

.icon-video {
    font-size: 31px;
    margin-top: 17px;
}

.icon-assessment {
    font-size: 51px;
    margin-top: 12px;
    margin-right: 5px;
}

img {
    width:28px;
    height:26px;
}
.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
}

.tags-place {
	border: 1px solid #e6e6e6!important;
    margin-left: 0;
    padding: 1px 10px;
    margin-top: 0;
	max-height: 112px;
	overflow-y:auto;
}

</style>



// WEBPACK FOOTER //
// src/app/learningContent/components/AssetEdit.vue